



























































































import {Component} from 'vue-property-decorator';
import {Getter} from 'vuex-class';
import {ScrollButton} from "wings-ui-components";
import SystemUsersFilter from '@/components/UserManagement/SystemUsers/SystemUsersFilter.vue';
import {SystemUserItem} from '@/store/user_management/system_users/types';
import BaseItemsPage from '@/pages/Pages/BaseItemsPage';
import AccountsFilter from "@/components/Settings/Accounts/AccountsFilter.vue";

@Component({components: {AccountsFilter, SystemUsersFilter, ScrollButton}})
export default class SystemUsers extends BaseItemsPage<SystemUserItem> {

  @Getter('systemUsers') systemUsersResponse!: SystemUserItem[];

  is_show_filter = false;

  currentSort= 'name';
  currentSortOrder= 'desc';
  tableFields = ['name', 'email', 'role', 'status'];

  getData(): SystemUserItem[] {
    return this.systemUsersResponse;
  }
}
